//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ICVDTYF',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: ''
      },
      dataList1: [
        {name: '35~39', value: '0'},
        {name: '40~44', value: '1'},
        {name: '45~49', value: '2'},
        {name: '50~54', value: '3'},
        {name: '55~59', value: '4'}
      ],
      dataList2: [
        {name: '<24', value: '0'},
        {name: '24~27', value: '1'},
        {name: '≥28', value: '2'}
      ],
      dataList3: [
        {value: '1', name: '是'},
        {value: '0', name: '否'}
      ],
      dataList4: [
        {name: '<120', value: '-2'},
        {name: '120~129', value: '0'},
        {name: '130~139', value: '1'},
        {name: '140~159', value: '2'},
        {name: '160~179', value: '3'},
        {name: '≥180', value: '4'}
      ],
      dataList5: [
        {value: '1', name: '≥5.20'},
        {value: '0', name: '<5.20'}
      ],
      dataList6: [
        {value: '2', name: '是'},
        {value: '0', name: '否'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }

      if (result === -2) {
        self.descTxt = '0.1'
      } else if (result === 0 || result === -1) {
        self.descTxt = '0.2'
      } else if (result === 1) {
        self.descTxt = '0.3'
      } else if (result === 2) {
        self.descTxt = '0.5'
      } else if (result === 3) {
        self.descTxt = '0.8'
      } else if (result === 4) {
        self.descTxt = '1.2'
      } else if (result === 5) {
        self.descTxt = '1.8'
      } else if (result === 6) {
        self.descTxt = '2.8'
      } else if (result === 7) {
        self.descTxt = '4.4'
      } else if (result === 8) {
        self.descTxt = '6.8'
      } else if (result === 9) {
        self.descTxt = '10.3'
      } else if (result === 10) {
        self.descTxt = '15.6'
      } else if (result === 11) {
        self.descTxt = '23.0'
      } else if (result === 12) {
        self.descTxt = '32.7'
      } else if (result >= 13) {
        self.descTxt = '43.1'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/ICVDTYF.vue